import { render, staticRenderFns } from "./EventPostEditView.vue?vue&type=template&id=13c48412&scoped=true&"
import script from "./EventPostEditView.vue?vue&type=script&lang=ts&"
export * from "./EventPostEditView.vue?vue&type=script&lang=ts&"
import style0 from "./EventPostEditView.vue?vue&type=style&index=0&id=13c48412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c48412",
  null
  
)

export default component.exports